import { createAction } from "@reduxjs/toolkit";
import type { KeyMomentType } from "../../types/post.types";

export { resetBroadcast, setAwayLogo, setAwayTeam, setBroadcastId, setBroadcastUserId, setFixtureDate, setFixtureId, setFullTimeAt, setHalfTimeAt, setHomeLogo, setHomeTeam, setLocation, setSecondHalfStartTime, setStartTime, setTimeCorrection, setVenue } from "./broadcast.slice";

export const createBroadcastRequest = createAction<{
	homeTeam: string;
	awayTeam: string;
	homeLogo?: string;
	awayLogo?: string;
	venue?: string;
	location?: string;
	fixtureId?: number;
	fixtureDate?: string;
}>("broadcast/createBroadcastRequest");

export const addPostRequest = createAction<{ broadcastId: string; text: string; share?: boolean; hashtags?: string[]; keyMomentType?: KeyMomentType; postType?: string }>(
	"broadcast/addPostRequest",
);

export const updatePostRequest = createAction<{
	broadcastId: string;
	postId: string;
	text: string;
}>("broadcast/updatePostRequest");

export const deletePostRequest = createAction<{
	broadcastId: string;
	postId: string;
}>("broadcast/deletePostRequest");

export const kickoffRequest = createAction<{ broadcastId: string; offsetMinutes?: number }>(
	"broadcast/kickoffRequest",
);

export const endBroadcastRequest = createAction<{ broadcastId: string }>(
	"broadcast/endBroadcastRequest",
);

export const halfTimeRequest = createAction<{ broadcastId: string }>(
	"broadcast/halfTimeRequest",
);

export const fullTimeRequest = createAction<{ broadcastId: string }>(
	"broadcast/fullTimeRequest",
);

export const secondHalfRequest = createAction<{ broadcastId: string }>(
	"broadcast/secondHalfRequest",
);

export const goalRequest = createAction<{ broadcastId: string; team: "home" | "away"; teamId?: number; action?: "add" | "remove"; scorerId?: number; comment?: string; share?: boolean; hashtags?: string[] }>(
	"broadcast/goalRequest",
);

export const varReviewRequest = createAction<{ broadcastId: string; active: boolean }>(
	"broadcast/varReviewRequest",
);

export const correctTimeRequest = createAction<{ broadcastId: string; minute: number }>(
	"broadcast/correctTimeRequest",
);

export const substitutionRequest = createAction<{
	broadcastId: string;
	team: "home" | "away";
	subs: { playerOut: string; playerIn: string }[];
}>("broadcast/substitutionRequest");

export const cardRequest = createAction<{
	broadcastId: string;
	team: "home" | "away";
	teamId?: number;
	player: string;
	playerId?: number;
	type: "yellow" | "2Yellow" | "red";
	comment?: string;
	share?: boolean;
	hashtags?: string[];
}>("broadcast/cardRequest");

export const removeCardRequest = createAction<{
	broadcastId: string;
	cardId: string;
}>("broadcast/removeCardRequest");

export const removeSubstitutionRequest = createAction<{
	broadcastId: string;
	substitutionId: string;
}>("broadcast/removeSubstitutionRequest");

export const removeSubPairRequest = createAction<{
	broadcastId: string;
	substitutionId: string;
	pairIndex: number;
}>("broadcast/removeSubPairRequest");

export const pollRequest = createAction<{
	broadcastId: string;
	question: string;
	options: string[];
}>("broadcast/pollRequest");

export const endPollRequest = createAction<{
	broadcastId: string;
	pollId: string;
	share?: boolean;
	hashtags?: string[];
	comment?: string;
}>("broadcast/endPollRequest");

export const replyToCommentRequest = createAction<{
	broadcastId: string;
	commentId: string;
	reply: string;
}>("broadcast/replyToCommentRequest");

export const shareCommentToFeedRequest = createAction<{
	broadcastId: string;
	commentId: string;
}>("broadcast/shareCommentToFeedRequest");

export const markCommentReadRequest = createAction<{
	broadcastId: string;
	commentId: string;
	read?: boolean;
}>("broadcast/markCommentReadRequest");

export const blockCommentUserRequest = createAction<{
	broadcastId: string;
	commentId: string;
}>("broadcast/blockCommentUserRequest");
